import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import copy from "copy-to-clipboard";
import { Copy } from "lucide-react";
import { showSuccessToast } from "../../../shared/Toasts";

interface Props {
  dataKey: string;
  dataValue: any;
  isCopyable?: boolean;
}

const StepIOLogModalSectionRow = ({ dataKey, dataValue, isCopyable = false }: Props) => {
  const displayDataKey = dataKey.replace(/_/g, " ");
  const displayValue =
    typeof dataValue === "object" && dataValue !== null
      ? JSON.stringify(dataValue, null, 2)
      : dataValue !== null
      ? dataValue.toString()
      : dataValue;

  const handleCopy = () => {
    copy(displayValue ?? "");
    showSuccessToast(`Copied ${displayDataKey} to clipboard`);
  };

  return (
    <div className="flex flex-col pt-2">
      <hr className="bg-gray-10 w-full m-0" />
      <div className="flex flex-row space-x-4 align-top pt-2">
        <Text variant="md-mono" className="w-[300px] shrink-0 break-all">
          {dataKey}
        </Text>
        <Text as="pre" variant="md-mono" className="flex-1 min-w-0 m-0 max-h-[400px]">
          {displayValue}
        </Text>
        {isCopyable && (
          <Button
            size="sm"
            variant={ButtonVariant.TertiaryWhite}
            leftIcon={<Copy size={12} />}
            ariaLabel={`Copy ${displayDataKey}`}
            onClick={handleCopy}
            className="shrink-0"
          >
            Copy
          </Button>
        )}
      </div>
    </div>
  );
};

export default StepIOLogModalSectionRow;
